<template lang="html">
  <content-block :controls="controls" :bg="false" :fresh="block.edit" @edit="editBlock()" @input="saveChanges()" @remove="deleteBlock()">
    <div v-if="edit">
      <div class="row">
        <label class="col-md-3">{{ $t('content_block_interruption_mark_label') }}</label>
        <div class="col-md-9">
          <input type="text" class="form-control" v-model="block.data.mark" />
        </div>
      </div>
      <div class="row">
        <label class="col-md-3">{{ $t('content_block_interruption_title_label') }}</label>
        <div class="col-md-9">
          <input type="text" class="form-control" v-model="block.data.title" />
        </div>
      </div>
      <div class="row">
        <label class="col-md-3">{{ $t('content_block_interruption_text_label') }}</label>
        <div class="col-md-9">
          <ckeditor v-model="block.data.text" ></ckeditor>
        </div>
      </div>
      <div class="row">
        <label class="col-md-3">{{ $t('content_block_interruption_backdrop_image_label') }}</label>

        <div class="col-md-3">
          <picture-input

            ref="pictureInput"
            @change="imageSelected"
            width="200"
            height="200"
            margin="0"
            accept="image/jpeg,image/png,image/svg"
            size="10"
            buttonClass="btn"
            :customStrings="{
                drag: 'Drag an image here'
              }">
          </picture-input>
        </div>
        <div class="col-md-3"  v-if="block.data.backdrop_image">
          <img style="max-width:100%;" v-bind:src="options.baseImagePath + '/' + block.data.backdrop_image" />
          <button class="btn btn-warning" @click.prevent="removeImage()">{{ $t('remove_image') }}</button>
        </div>
      </div>
      <div class="row">
        <label class="col-md-3">{{ $t('content_block_interruption_info_bg_label') }}</label>

        <div class="col-md-3">
          <picture-input

            ref="infoPictureInput"
            @change="infoImageSelected"
            width="200"
            height="200"
            margin="0"
            accept="image/jpeg,image/png,image/svg"
            size="10"
            buttonClass="btn"
            :customStrings="{
                drag: 'Drag an image here'
              }">
          </picture-input>
        </div>
        <div class="col-md-3"  v-if="block.data.info_bg_url">
          <img style="max-width:100%;" v-bind:src="options.baseImagePath + '/' + block.data.info_bg_url" />
          <button class="btn btn-warning" @click.prevent="removeInfoImage()">{{ $t('remove_image') }}</button>
        </div>
      </div>
    </div>
    <div v-else="edit" class="content_block__interruption cb_interruption">
      <div class="cb_interruption__backdrop" :style="{ 'background-image' : 'url(' + options.baseImagePath + '/' + block.data.backdrop_image + ')' }"></div>
      <div class="cb_interruption__info" :style="{ 'background-image' : 'url(' + options.baseImagePath + '/' + block.data.info_bg_url + ')' }">
        <div class="cb_interruption__mark">{{ block.data.mark }}</div>
        <div class="cb_interruption__title">{{ block.data.title }}</div>
        <div class="cb_interruption__text" v-html="block.data.text"></div>
      </div>
    </div>
  </content-block>
</template>

<script>
  import ContentBlock from './ContentBlock'
  import PictureInput from 'vue-picture-input'
  import { Form } from 'vform'

  export default {
    components: {
      ContentBlock,
      PictureInput
    },
    name: "ContentBlockInterruption",
    props: {
      block: {
        type: Object,
      },
      options: {
        type: Object,
        default: () => ({
          postImageUrl: '/upload/post'
        })
      },
      controls: {
        type: Boolean,
        default: false
      },
    },
    data () {
      return {
        edit: false
      }
    },
    mounted () {
      if (this.controls) {
        this.edit = this.block.edit || false;
      }
    },
    methods: {
      editBlock () {
        this.edit = true;
      },
      deleteBlock () {
        this.$emit('remove')
      },
      saveChanges() {
        this.edit = false;
        this.$emit('input', this.block)
      },
      async removeImage (field) {

        let specialForm = new Form({
          image_name: this.block.data.backdrop_image
        });

        await specialForm.delete(this.options.postImageUrl);

        this.block.data.backdrop_image = '';
      },
      async removeInfoImage (field) {

        let specialForm = new Form({
          image_name: this.block.data.info_bg_url
        });

        await specialForm.delete(this.options.postImageUrl);

        this.block.data.info_bg_url = '';
      },

      async imageSelected () {
        let res;

        let specialForm = new Form({
          image: this.$refs.pictureInput.file,
          old_image_name: ''
        });

        if (this.block.data.backdrop_image) {
          specialForm['old_image_name'] = this.block.data.backdrop_image;
        }

        const { data } = await specialForm.post(this.options.postImageUrl);
        this.block.data.backdrop_image = data
      },

      async infoImageSelected () {
        let res;

        let specialForm = new Form({
          image: this.$refs.infoPictureInput.file,
          old_image_name: ''
        });

        if (this.block.data.info_bg_url) {
          specialForm['old_image_name'] = this.block.data.info_bg_url;
        }

        const { data } = await specialForm.post(this.options.postImageUrl);
        this.block.data.info_bg_url = data
      },
    }
  }
</script>
